type StarsProps = {
    count: number
    starFillType: string
}

export enum STARS_ENUMS {
    FULL = 'FULL',
    HALF = 'HALF',
    EMPTY = 'EMPTY'
}

export const Stars = ({ count, starFillType }: StarsProps) => {
    const getStarsFilled = () => {
        switch (starFillType) {
            case 'EMPTY':
                return (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 15.8 15.1"
                        width="17"
                        height="17"
                    >
                        <polygon points="3.9 9.6 3 15.1 7.9 12.5 12.8 15 11.9 9.6 15.8 5.8 10.3 5 7.9 0 5.5 5 0 5.8 3.9 9.6" />
                        <polygon
                            fill="#fff"
                            points="13.7 6.5 9.7 5.9 7.9 2.3 7.9 2.28 6.1 5.88 2.1 6.48 5 9.28 4.3 13.28 7.9 11.38 7.9 11.4 11.5 13.3 10.8 9.3 13.7 6.5"
                        />
                    </svg>
                )
            case 'HALF':
                return (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 15.8 15.1"
                        width="17"
                        height="17"
                    >
                        <path d="M3.9,9.6l-.9,5.5,4.9-2.6,4.9,2.5-.9-5.4,3.9-3.8-5.5-.8L7.9,0l-2.4,5L0,5.8l3.9,3.8Zm4,1.8V2.3l1.8,3.6,4,.6-2.9,2.8,.7,4-3.6-1.9Z" />
                    </svg>
                )
            case 'FULL':
            default:
                return (
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 15.8 15.1"
                        width="17"
                        height="17"
                    >
                        <polygon points="3.9 9.6 3 15.1 7.9 12.5 12.8 15 11.9 9.6 15.8 5.8 10.3 5 7.9 0 5.5 5 0 5.8 3.9 9.6" />
                        <polygon points="7.9 11.4 7.9 2.3 9.7 5.9 13.7 6.5 10.8 9.3 11.5 13.3 7.9 11.4" />
                        <polygon points="4.3 13.28 5 9.28 2.1 6.48 6.1 5.88 7.9 2.28 7.9 11.38 4.3 13.28" />
                    </svg>
                )
        }
    }
    return <>{Array.from(Array(count), (_, i) => getStarsFilled())}</>
}
